<template>
  <div class="tree-container">
    <div class="campaign-details__treeview-header ">
      {{ t('Flow preview') }}
      <ui-button
        size="mini"
        icon="fas fa-edit"
        :text="t('Edit')"
        @click="openEditFlowDialog"
      />
    </div>

    <LoadingCircle v-if="loading" width="20" height="20" class="mt-24 mb-24" />
    <ui-treeview
      v-if="!loading"
      :items="flowMap"
    >
      <template #default="{ item }">
        <div class="create-campaign-dialog-flow-preview__item">
          <div
            class="condition create-campaign-dialog-flow-preview__condition"
            :class="{
              'create-campaign-dialog-flow-preview__condition--inactive': item.inactive,
            }"
          >
            <ui-icon
              v-if="item.inactive"
              class="mr-4"
              :disabled="true"
              icon="fas fa-pause"
            ></ui-icon>
            <span v-if="item.name">{{ translatedName(item) }}</span>
            <template v-else-if="item.conditions">
              <span
                class="condition__rule"
                :class="{ 'condition__rule--opposite-rule': isOppositeFlowRulePredicate(item.conditions[0].predicate) }"
              >{{ item.conditions[0].name }}</span>
              <span v-if="item.conditions.length > 1">&nbsp;({{ tc('+{0} conditions', item.conditions.length - 1, [item.conditions.length - 1]) }})</span>
            </template>
            <span v-else>{{ t('Empty') }}</span>
          </div>

          <div v-if="!item.inactive && isShowWeight(item.type)">
            {{ item.weight }} ({{ item.weightPercent }})%
          </div>
        </div>
      </template>
    </ui-treeview>
  </div>
</template>

<script setup lang="ts">
import LoadingCircle from '@/components/loading-circle.vue';
import { tc, useI18n } from '@/composables';
import { useCampaignFlowPreview } from './useCampaignFlowPreview';

const props = defineProps<{
  flow: Flow;
  updateFlow: (flow: Flow) => void;
}>();

const { t } = useI18n();

const {
  loading,
  flowMap,
  translatedName,
  isOppositeFlowRulePredicate,
  isShowWeight,
  openEditFlowDialog,
} = useCampaignFlowPreview(() => ({
  flow: props.flow,
  updateFlow: props.updateFlow,
}));
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
  .create-campaign-dialog-flow-preview {
    &__item {
      justify-content: space-between;
      overflow-x: hidden;
      text-overflow: ellipsis;
      width: 100%;
      white-space: nowrap;
      display: flex;
    }

    &__condition {
      display: inline-flex;
      align-items: baseline;

      &--inactive {
        color: var(--color-gray20);
      }
    }
  }
</style>
